import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import Translate from 'react-translate-component';

import DocumentScript from 'components/cards/document/preview/DocumentScript';

export default class EventScriptModal extends Component {
    static propTypes = {
        modal: PropTypes.object.isRequired,
        params: PropTypes.shape({
            body: PropTypes.object,
            options: PropTypes.object,
            onComplete: PropTypes.func,
        }),
    };

    save = (result) => {
        this.props.modal.onCancel();
        this.props.params.onComplete(result);
    }

    render() {
        const { modal, params } = this.props;

        return (
            <Modal
                {...modal}
                width="96%"
                className="modal-full card-modal player-modal"
                title={<Translate content="events.formResult" />}
                footer={null}
            >
                <DocumentScript
                    body={params.body}
                    onComplete={this.save}
                    options={params.options}
                />
            </Modal>
        );
    }
}
